
  import createMeisterIcons from '../src/createMeisterIcons';

  const MicAlt = createMeisterIcons("mic-alt", [["path",{"fill":"currentColor","d":"M12 5.75c-1.286 0-2.25.964-2.25 2.25v4c0 1.286.964 2.25 2.25 2.25.927 0 1.78-.65 2.107-1.5H12a.75.75 0 0 1 0-1.5h2.25v-1.5H12a.75.75 0 0 1 0-1.5h2.25V8c0-1.286-.964-2.25-2.25-2.25M15.75 12V8c0-2.114-1.636-3.75-3.75-3.75S8.25 5.886 8.25 8v4c0 1.856 1.261 3.344 3 3.68v2.57H9a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-2.25v-2.58c1.677-.365 3-1.911 3-3.67","key":"0dfa9c8aba919702da36549dc7532441fb857116","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default MicAlt
  